import { Box, Skeleton, Stack } from '@mui/material';


export const LoadingSkeleton = () => {

  return <Stack spacing={2}>
    <Skeleton variant="rectangular" width='100%' height={80} />
    <Skeleton variant="rectangular" width='100%' height={100} />
    <Skeleton variant="rectangular" width='100%' height={100} />
  </Stack>
};
